import {
  DEFAULT_BASE_URL,
  DEFAULT_BASE_URL_V2,
  PATH_CHANNEL,
  PATH_TOKEN_CARD,
  PATH_TOKEN_CARD_DELETE,
  PATH_CHARGE_PAYER,
  PATH_CREATE_DATA_INIT_PAYMENT,
  PATH_CREATE_DATA_INIT_PAYMENT_V2,
  PATH_INIT_PAYMENT,
  PATH_INQUIRY_BILL,
  PATH_INQUIRY_POLICY,
  PATH_INQUIRY_REQUEST_ITEM,
  PATH_UPDATE_STATUS_PAY,
  PATH_GET_ORDER_DETAIL
} from "./const-from-env";

const BASE_URL = DEFAULT_BASE_URL;

const BASE_URL_V2 = DEFAULT_BASE_URL_V2;

export const API_PATH = {
  INQUIRY_POLICY: `${BASE_URL}${PATH_INQUIRY_POLICY}`,
  CHANNEL: `${BASE_URL}${PATH_CHANNEL}`,
  TOKEN_CARD: `${BASE_URL}${PATH_TOKEN_CARD}`,
  TOKEN_CARD_DELETE: `${BASE_URL}${PATH_TOKEN_CARD_DELETE}`,
  INIT_PAYMENT: `${BASE_URL}${PATH_INIT_PAYMENT}`,
  INQUIRY_BILL: `${BASE_URL}${PATH_INQUIRY_BILL}`,
  CREATE_DATA_INIT_PAYMENT: `${BASE_URL}${PATH_CREATE_DATA_INIT_PAYMENT}`,
  UPDATE_STATUS_PAY: `${BASE_URL}${PATH_UPDATE_STATUS_PAY}`,
  CREATE_DATA_INIT_PAYMENT_V2: `${BASE_URL_V2}${PATH_CREATE_DATA_INIT_PAYMENT_V2}`,
  CHARGE_PAYER: `${BASE_URL}${PATH_CHARGE_PAYER}`,
  INQUIRY_REQUEST_ITEM: `${BASE_URL}${PATH_INQUIRY_REQUEST_ITEM}`,
  GET_ORDER_DETAIL: `${BASE_URL}${PATH_GET_ORDER_DETAIL}`
};
